import { createSlice } from "@reduxjs/toolkit";
import { set } from "lodash";

const PowerBICredsSlice = createSlice({
  name: "powerBICreds",
  initialState: {
    latestCallDateTime: null, 
    latestNonCommercialDataCallDateTime: null,
    data: {},
    nonCommercialData: {}
  },
  reducers: {
    setPowerBICreds: (powerBICreds, action) => {
      const { data } = action.payload;
      powerBICreds.data = data;
      powerBICreds.latestCallDateTime = new Date().getTime();
    },
    setNonCommercialPowerBICreds: (powerBICreds, action) => {
      const { data } = action.payload;
      powerBICreds.nonCommercialData = data;
      powerBICreds.latestNonCommercialDataCallDateTime = new Date().getTime();
    },
  },
});

export const { setPowerBICreds, setNonCommercialPowerBICreds } = PowerBICredsSlice.actions;
export default PowerBICredsSlice.reducer;
